import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { RiskQuestionsSurveyOption } from '../../models';

@Component({
  selector: 'app-inyova-grow-single-box',
  templateUrl: './inyova-grow-single-box.component.html',
  styleUrls: ['./inyova-grow-single-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InyovaGrowSingleBoxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class InyovaGrowSingleBoxComponent implements ControlValueAccessor {
  @Input() hasError: boolean;
  @Input() title: string;
  @Input() hint: string;
  @Input() chips: boolean;
  @Input() options: RiskQuestionsSurveyOption[];
  @Output() toggleHintHandler = new EventEmitter<any>();

  showHint = false;

  value: string | number = '';
  private onChange: (value: number | string) => void;
  private onTouched: () => void;

  toggleHint() {
    this.showHint = !this.showHint;
    this.toggleHintHandler.emit();
  }

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onOptionChange(value: number) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
